const getDate = (e?: string) => {
  return e ? e.split("T")[0] : "";
};

export default getDate;
